import { Remotes } from './types';

export default [
  {
    url: '/assets/projects/assets-no-cache/remoteEntry.js',
    scope: 'accProjectList',
  },
  {
    url: '/assets/demo-app/assets-no-cache/remoteEntry.js',
    scope: 'accDemoApp',
  },
  {
    url: '/assets/correspondence/assets-no-cache/remoteEntry.js',
    scope: 'accCorrespondence',
  },
  {
    url: '/assets/meetings/assets-no-cache/remoteEntry.js',
    scope: 'accMeetings',
  },
  {
    url: '/assets/photos/assets-no-cache/remoteEntry.js',
    scope: 'acsPhotos',
  },
  {
    url: '/assets/rfis/assets-no-cache/remoteEntry.js',
    scope: 'accRfis',
  },
  {
    url: '/assets/schedule/assets-no-cache/remoteEntry.js',
    scope: 'accSchedule',
  },
  {
    url: '/assets/docs/assets-no-cache/remoteEntry.js',
    scope: 'accDocs',
  },
  {
    url: '/assets/home/assets-no-cache/remoteEntry.js',
    scope: 'accUserHome',
  },
  {
    url: '/assets/specs/assets-no-cache/remoteEntry.js',
    scope: 'accSpecs',
  },
  {
    url: '/assets/submittals/assets-no-cache/remoteEntry.js',
    scope: 'accSubmittals',
  },
  {
    url: '/assets/notifications/assets-no-cache/remoteEntry.js',
    scope: 'accNotifications',
  },
  {
    url: '/assets/handover/assets-no-cache/remoteEntry.js',
    scope: 'accHandover',
  },
  {
    url: '/assets/share/assets-no-cache/remoteEntry.js',
    scope: 'accDocsShare',
  },
  {
    url: '/assets/components/assets-no-cache/remoteEntry.js',
    scope: 'accLibrary',
  },
  {
    url: '/assets/bridge/assets-no-cache/remoteEntry.js',
    scope: 'accBridge',
  },
  {
    url: '/assets/template-admin/assets-no-cache/remoteEntry.js',
    scope: 'accTemplateAdmin',
  },
  {
    url: '/assets/template-settings/assets-no-cache/remoteEntry.js',
    scope: 'accTemplateSettings',
  },
  {
    url: '/assets/admin/assets-no-cache/remoteEntry.js',
    scope: 'accAdminClient',
  },
  {
    url: '/assets/reports/assets-no-cache/remoteEntry.js',
    scope: 'accReports',
  },
  {
    url: '/assets/cost/assets-no-cache/remoteEntry.js',
    scope: 'accCost',
  },
  {
    url: '/assets/autospecs/assets-no-cache/remoteEntry.js',
    scope: 'accAutoSpecs',
  },
  {
    url: '/assets/issues/assets-no-cache/remoteEntry.js',
    scope: 'accIssues',
  },
] satisfies Remotes;
